import React from 'react';

import isArchived from 'archive/isArchived';
import {RequestSchema, SCHEMA_ID_REQUEST_SCHEMA_ALL} from 'requests/RequestConstants';
import {SingleValueFilter} from 'search/SearchConstants';
import pickDefined from 'util/pickDefined';

import DropdownFilterForm, {prefixedToggleText} from './base/DropdownFilterForm';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import useFilterArchivedDropdownOptions, {
  ArchivableOptionData,
} from './base/useFilterArchivedDropdownOptions';

interface RequestSchemaFilterFormProps extends BaseFilterFormProps {
  filter: SingleValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: SingleValueFilter) => void;
  onRemove?: () => void;
}
export interface RequestSchemaFilterFormExtraProps {
  assaySchemas: Array<RequestSchema>;
}

function _buildOptionDatas(requestSchemas: Array<RequestSchema>): Array<ArchivableOptionData> {
  return [
    {name: 'All', value: SCHEMA_ID_REQUEST_SCHEMA_ALL, isArchived: false},
    ...requestSchemas.map((requestSchema) => ({
      name: requestSchema.name,
      value: requestSchema.id,
      isArchived: isArchived(requestSchema),
    })),
  ];
}

function RequestSchemaFilterForm(
  props: RequestSchemaFilterFormProps & RequestSchemaFilterFormExtraProps
): JSX.Element {
  const {filter, onChangeFilter, filterStyle, onRemove, assaySchemas} = props;
  const optionDatas = _buildOptionDatas(assaySchemas);
  const onChangeValueBase = (value: string): void => {
    onChangeFilter({...filter, value});
  };
  const filterArchivedDropdownOptionProps = useFilterArchivedDropdownOptions(
    optionDatas,
    'Show archived schemas',
    onChangeValueBase
  );
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <DropdownFilterForm
      {...skeletonProps}
      {...filterArchivedDropdownOptionProps}
      dropdownToggleText={prefixedToggleText('Type', optionDatas, filter)}
      filterStyle={filterStyle}
      isMulti={false}
      isSearchable={true}
      onRemove={onRemove}
      value={filter.value}
    />
  );
}

export default RequestSchemaFilterForm;
